/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod';

export const timesheetDocumentSummaryDtoSchema = z.object({
  id: z.coerce.number().int(),
  fileName: z.coerce.string(),
  description: z.coerce.string().nullable().nullish(),
  contentType: z.coerce.string(),
  fileExtension: z.coerce.string(),
  fileSizeBytes: z.coerce.number().int(),
  uploadedAt: z.string().datetime({ local: true }),
  updatedAt: z.string().datetime({ local: true }),
  uploadedByUserId: z.coerce.number().int().nullable().nullish(),
  linkedStatiniCount: z.coerce.number().int(),
});
